import './optionsSelector.scss';

import { FormattedMessage } from 'react-intl';
import {
  ActionIcon,
  ActionIconColor,
  ActionIconVariant,
  Size,
} from '@eliberty/design-system-react';

import { SELECTOR_MODE } from '~constants';
import { OptionSelectorBooking, OptionSelectorSimple } from '~organisms';
import { AvailableOption, OrderItemType } from '~types/appsync.types';
import { Participant } from '~types/participant';

/**
 * OptionsSelector component allows users ...
 */
interface OptionsSelectorProps {
  /** The selected date */
  date?: Date;
  /** The options to display */
  options: AvailableOption[];
  /** List of selectable participants */
  participants: Participant[];
  /** Currency of option price */
  currency: string;
  /** The participant selection mode */
  participantMode: SELECTOR_MODE;
  /** The callback function called when participants are updated */
  onChangeParticipants: (participants: Participant[]) => void;
  /** The callback function called when the back button is clicked */
  onClickBackButton: () => void;
  /** Whether to show the header with back button and title (default: true) */
  showHeader?: boolean;
  /** When true, booking options display their content inline instead of in a modal */
  inlineBooking?: boolean;
}

const OptionsSelector = ({
  date,
  options,
  participants,
  currency,
  participantMode,
  onChangeParticipants,
  onClickBackButton,
  showHeader = true,
  inlineBooking = false,
}: OptionsSelectorProps) => {
  return (
    <div className='OptionsSelector'>
      {showHeader && (
        <div className='OptionsSelector_backButton'>
          <ActionIcon
            icon='arrow-left'
            label='Icon arrow left'
            size={Size.S}
            color={ActionIconColor.Black}
            variant={ActionIconVariant.Ghost}
            onClick={onClickBackButton}
          />
          <div className='OptionsSelector_title'>
            <FormattedMessage defaultMessage='Options' id='options' />
          </div>
        </div>
      )}
      {options
        .filter((option) => OrderItemType.Support !== option.type)
        .map((option) => {
          if (option.isBooking && date) {
            return (
              <OptionSelectorBooking
                key={option.slug}
                date={date}
                option={option}
                participants={participants}
                currency={currency}
                participantMode={participantMode}
                onParticipantsChange={onChangeParticipants}
                inlineBooking={inlineBooking}
              />
            );
          }

          if (!option.mandatory) {
            return (
              <OptionSelectorSimple
                key={option.slug}
                option={option}
                participants={participants}
                currency={currency}
                participantMode={participantMode}
                onParticipantsChange={onChangeParticipants}
              />
            );
          }

          return null;
        })}
    </div>
  );
};

export default OptionsSelector;
